import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import LessonPlanDTO from '../models/lessonplan/LessonPlanDTO';

export class LessonPlanApiController {
    // get: LessonPlan/GetAllLessonPlans
    public RouteGetAllLessonPlans = () => `LessonPlan/GetAllLessonPlans`;
    public getAllLessonPlans(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<LessonPlanDTO[]>> {
        let url = this.RouteGetAllLessonPlans();
        return HttpApi.RestRequest<any, LessonPlanDTO[]>(null, 'get', url, requestOptions);
    }
}
var service = new LessonPlanApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/LessonPlanApiController.ts